import type { Reviewer } from 'models/ApprovalWorkFlow';

import { FormattedDateTime } from '@molecules/FormattedDateTime';

export const formatApprovalNames = (approvals: Reviewer[], userId: number) => {
  return approvals.map((approval) => {
    return (
      <div
        key={approval.user_id}
        className="flex items-center justify-between gap-3 border-b first-of-type:pt-0 last-of-type:border-0"
      >
        <div>{approval.user_id === userId ? 'You' : approval.user_name}</div>
        <div className="text-right">
          <FormattedDateTime value={approval.created_at} />
        </div>
      </div>
    );
  });
};
